import { Suspense, lazy } from 'react';

const EditionsShelf = lazy(() => import('./editions/EditionsShelf'));

function App() {
  return (
    <Suspense fallback={<div style={{ padding: 24, fontFamily: 'system-ui' }}>Loading…</div>}>
      <EditionsShelf />
    </Suspense>
  );
}

export default App;
